import { __rest } from "tslib";
import React from 'react';
import { makeStyles, Tab as MuiTab } from '@material-ui/core';
import { Button } from './../../';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2, 1),
    },
}));
export const Tab = (_a) => {
    var { buttonProps, disabled, label } = _a, otherProps = __rest(_a, ["buttonProps", "disabled", "label"]);
    const classes = useStyles();
    return (React.createElement(MuiTab, Object.assign({ classes: classes, tabIndex: -1, component: "div", label: React.createElement(Button, Object.assign({ disabled: disabled, style: { height: 30 } }, buttonProps), label), disabled: disabled }, otherProps)));
};
